import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "./Logo";
import { SITE } from "@/data/site";

const Footer = () => (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-obsidian overflow-hidden">
        <div className="mx-auto max-w-7xl px-6 md:px-10 pt-24 pb-10">
            <div className="grid gap-16 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-3">
                        <LogoMark size={30} />
                        <span className="font-display font-extrabold text-lg tracking-tight">
                            pocket<span className="text-gold">folio</span>
                            <span className="text-zinc-500 font-medium text-sm">.ai</span>
                        </span>
                    </div>
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-zinc-400">
                        Forex trading bots, high-conviction signals and structured education across
                        commodities, stocks and ETFs. Engineered with discipline, delivered with transparency.
                    </p>
                    <a
                        href={`mailto:${SITE.email}`}
                        data-testid="footer-email-link"
                        className="mt-8 inline-flex items-center gap-2 text-sm text-gold hover:text-gold-light transition-colors duration-300"
                    >
                        {SITE.email} <ArrowUpRight size={14} />
                    </a>
                </div>
                <div className="lg:col-span-2">
                    <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Explore</h4>
                    <ul className="mt-6 space-y-3 text-sm">
                        {[
                            ["/", "Home"],
                            ["/about", "About"],
                            ["/services", "Services"],
                            ["/pricing", "Pricing"],
                            ["/markets", "Live Markets"],
                            ["/blog", "Insights"],
                            ["/contact", "Contact"],
                        ].map(([to, label]) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="text-zinc-400 hover:text-white transition-colors duration-300"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="lg:col-span-2">
                    <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Services</h4>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/services#bots" data-testid="footer-link-bots" className="text-zinc-400 hover:text-white transition-colors duration-300">Trading Bots</Link></li>
                        <li><Link to="/services#signals" data-testid="footer-link-signals" className="text-zinc-400 hover:text-white transition-colors duration-300">Forex Signals</Link></li>
                        <li><Link to="/services#education" data-testid="footer-link-education" className="text-zinc-400 hover:text-white transition-colors duration-300">Education</Link></li>
                    </ul>
                    <h4 className="mt-10 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Legal</h4>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/legal/privacy-policy" data-testid="footer-link-privacy" className="text-zinc-400 hover:text-white transition-colors duration-300">Privacy Policy</Link></li>
                        <li><Link to="/legal/terms" data-testid="footer-link-terms" className="text-zinc-400 hover:text-white transition-colors duration-300">Terms & Conditions</Link></li>
                        <li><Link to="/legal/risk-disclosure" data-testid="footer-link-risk" className="text-zinc-400 hover:text-white transition-colors duration-300">Risk Disclosure</Link></li>
                    </ul>
                </div>
                <div className="lg:col-span-3">
                    <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">Registered Office</h4>
                    <address data-testid="footer-address" className="mt-6 not-italic text-sm leading-relaxed text-zinc-400">
                        {SITE.address.map((line) => (
                            <span key={line} className="block">{line}</span>
                        ))}
                    </address>
                </div>
            </div>

            <div className="mt-24 select-none" aria-hidden="true">
                <p className="text-outline font-display font-black tracking-tighter leading-[0.8] text-[13vw] whitespace-nowrap">
                    POCKETFOLIO
                </p>
            </div>

            <div className="mt-16 border-t border-white/10 pt-8">
                <p className="text-xs leading-relaxed text-zinc-500 max-w-4xl" data-testid="footer-risk-disclaimer">
                    Risk warning: Trading foreign exchange, commodities, stocks and ETFs on margin carries a
                    high level of risk and may not be suitable for all investors. Past performance of any
                    trading bot, signal service or strategy is not indicative of future results. You should
                    never trade with capital you cannot afford to lose.
                </p>
                <div className="mt-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                    <p className="font-mono text-xs text-zinc-500">
                        © 2026 {SITE.name} Ltd — {SITE.domain}
                    </p>
                    <p className="font-mono text-xs text-zinc-600">
                        Registered in the Union of the Comoros
                    </p>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
